export default __webpack_public_path__ + "static/media/categoryIcon.0b6540f4.svg";